import React, { useEffect } from 'react';
import { tablePaginationValues } from './listTableHelpers';
import Pagination1 from '../../images/Icon_Pagination_01.png';
import Pagination2 from '../../images/Icon_Pagination_02.png';
import Pagination3 from '../../images/Icon_Pagination_03.png';
import Pagination4 from '../../images/Icon_Pagination_04.png';

type Props = {
    listUrl: string;
    infoListData?: any;
    loadInfoTableList: (listUrl: string, paramsArr?: any) => void;
};

export const ListPagination: React.FC<Props> = ({
    listUrl,
    infoListData,
    loadInfoTableList
}) => {
    const { 
        pageNumber,
        pageSize,
        resultsCount,
        totalPages, 
        ddValArr, 
        itemNumStart, 
        itemNumEnd, 
        previousBtnsInactive, 
        nextBtnsInactive,
        pageSizeViaDropdown, 
        goToPageViaInput,
        goToFirstPage,
        goToPreviousPage,
        goToNextPage,
        goToLastPage
    } = tablePaginationValues(infoListData, listUrl, loadInfoTableList);

    useEffect(() => {
        if(resultsCount <= 0 && pageNumber > 1){
            goToPreviousPage();
        }
    }, [pageNumber, resultsCount]);    
    
    return (
        <React.Fragment>
            {infoListData && 
                <div className="TableNavigation">
                    <div className="PaginatonButtons">
                        <div className="PaginationButtonsLeft">
                            <button className="PaginatorBtn First" disabled={previousBtnsInactive} onClick={() => goToFirstPage()}>
                                <img src={Pagination1} alt="First" />
                            </button>
                            <button className="PaginatorBtn" disabled={previousBtnsInactive} onClick={() => goToPreviousPage()}>
                                <img src={Pagination2} alt="Back" />
                            </button>
                        </div>
                        <div className="PageNumber">
                            <div className="PageNumberInput">
                                <div className="FormBox">
                                    <div className="FormField">
                                        <select name="pageSize" className="DropDown" defaultValue={pageSize} onChange={(e) => pageSizeViaDropdown(e)}>
                                            {ddValArr.map((item: any) => {
                                                return (
                                                    <option className="DropDownOption" key={"pagination_option_" + item} value={item}>{item}</option>
                                                );
                                            })}
                                        </select>
                                    </div>
                                </div>
                                <div className="PageNumDetails">
                                    <span className="PageLabel">Page</span>
                                    <input name="pageNumber" type="text" className="EditBox" defaultValue={pageNumber} onKeyUp={(e) => goToPageViaInput(e)} />
                                    <span className="OfNumLabel">of {totalPages}</span>
                                </div>
                            </div>
                        </div>
                        <div className="PaginationButtonsMobile">
                            <div className="PaginationButtonsLeft Mobile">
                                <button className="PaginatorBtn First" disabled={previousBtnsInactive} onClick={() => goToFirstPage()}>
                                    <img src={Pagination1} alt="First" />
                                </button>
                                <button className="PaginatorBtn" disabled={previousBtnsInactive} onClick={() => goToPreviousPage()}>
                                    <img src={Pagination2} alt="Back" />
                                </button>
                            </div>
                            <div className="PaginationButtonsRight">
                                <button className="PaginatorBtn" disabled={nextBtnsInactive} onClick={() => goToNextPage()}>
                                    <img src={Pagination3} alt="Next" />
                                </button>
                                <button className="PaginatorBtn Last" disabled={nextBtnsInactive} onClick={() => goToLastPage()}>
                                    <img src={Pagination4} alt="Last" />
                                </button>
                            </div>
                        </div>
                    </div>
                    {resultsCount ?
                        <div className="PaginatorInfo">Showing {itemNumStart}-{itemNumEnd} of {resultsCount}</div>
                        :
                        null
                    }
                </div>
            }
        </React.Fragment>
    );
};